import { useState } from 'react';
import { Redirect, Route, useLocation } from 'react-router';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CommunityPage } from './CommunityPage';
import { CommunityNoCareMapPage } from './CommunityNoCareMapPage';
import { ViewNoteWithQueryParamDrawer } from '../notes/view-note/ViewNoteWithQueryParamDrawer';
import { AddNoteWithQueryParamDrawer } from '../notes/add-note/AddNoteWithQueryParamDrawer';
import { CommentFocusRequests } from '../notes/view-note/CommentFocusRequests';

// The feed is gone: its url is the Community page, and a post link is the note itself, in the
// notes page's view-note drawer. Old links arrive from notifications, bookmarks and history.
const FeedRedirect: React.FC<{ careMapId: string; }> = ({ careMapId }) => {
    const { search } = useLocation();
    const viewNoteDrawer = useInstance(ViewNoteWithQueryParamDrawer);
    const addNoteDrawer = useInstance(AddNoteWithQueryParamDrawer);
    const commentFocusRequests = useInstance(CommentFocusRequests);
    const [commentRequest] = useState(() => commentFocusRequests.create());

    const drawer = new URLSearchParams(search).get('drawer');

    let params: { mode?: string; postId?: string; addComment?: boolean } = {};
    if (drawer) {
        try {
            params = JSON.parse(drawer) ?? {};
        }
        catch {
            // not a drawer link we made: just land on the page
        }
    }

    if ((params.mode === 'view-community-post' || params.mode === 'edit-community-post') && params.postId) {
        return <Redirect to={viewNoteDrawer.getUrlForCareMap(careMapId, { noteId: params.postId, addComment: params.addComment ? commentRequest : undefined })} />;
    }
    if (params.mode === 'add-community-post') {
        // a post was always shared
        return <Redirect to={addNoteDrawer.getUrlForCareMap(careMapId, { shared: true })} />;
    }
    return <Redirect to={`/community/${careMapId}`} />;
};

export const CommunityRouteHandler: React.FC = () => (
    <>
        <Route exact path="/community/:caremapId" render={routeParams => {
            const caremapId = routeParams.match.params.caremapId;
            return caremapId === 'undefined'
                ? <CommunityNoCareMapPage />
                : <CommunityPage careMapId={caremapId} />
            ;
        }} />
        <Route exact path="/community/:caremapId/feed" render={routeParams => (
            <FeedRedirect careMapId={routeParams.match.params.caremapId} />
        )} />
    </>
);
